<template>
  <div class="p-all" v-if="!isAllowed">
    <a-alert
      message="Invalid Access"
      description="You don't have permission of this page!"
      type="error"
    />
  </div>
  <a-layout-content v-else :class="!isHrd ? 'p-all' : ''">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" :xxl="{ span: 6 }">
        <a-card bordered hoverable class="m-card-w-photo">
          <div slot="cover">
            <img
              alt="profile-pic"
              v-if="data.profile"
              ref="picProfiles"
              :src="$serviceUrl + data.profile.foto"
            />
          </div>
          <a-card-meta>
            <template slot="description">
              <div class="d-flex justify-between">
                <span>&nbsp;</span>
                <a-tag color="green" style="color:green!important;align-content: center;" v-if="data.profile && data.profile.status == 'Aktif'">{{data.profile.status.toUpperCase()}}</a-tag>
                <a-tag color="red" style="color:red!important;align-content: center;" v-if="data.profile && data.profile.status == 'Non Aktif'">{{data.profile.status.toUpperCase()}}</a-tag>
              </div>
              <h2 class="m-remove">{{ data.profile.nama_lengkap }}</h2>
              <h4>{{ data.profile.nama_sekolah }}</h4>
              <a-menu
                class="transparent"
                mode="vertical"
                @click="handleClick"
                :selectedKeys="[clicked]"
              >
                <a-menu-item key="profile">
                  <router-link
                    :to="
                      !isHrd
                        ? { name: 'hrd.siswa.profile' }
                        : { name: 'hrd.siswa.profile' }
                    "
                  >
                    <a-icon type="user" />Profile
                  </router-link>
                </a-menu-item>
                <a-menu-item key="dokumen">
                  <router-link
                    :to="
                      !isHrd
                        ? { name: 'hrd.siswa.dokumen' }
                        : { name: 'hrd.siswa.dokumen' }
                    "
                  >
                    <a-icon type="file" />Dokumen
                  </router-link>
                </a-menu-item>
                <a-menu-item key="kegiatan">
                  <router-link
                    :to="
                      !isHrd
                        ? { name: 'hrd.siswa.kegiatan' }
                        : { name: 'hrd.siswa.kegiatan' }
                    "
                  >
                    <a-icon type="solution" />Kegiatan
                  </router-link>
                </a-menu-item>
              </a-menu>
            </template>
          </a-card-meta>
          <a-divider></a-divider>
          <div class="d-flex justify-between">
            <a-upload
              v-if="getAuth.divisi[0] == 'HRD' && data.profile.status=='Aktif'"
              class="floating-button"
              accept="image/*"
              :showUploadList="false"
              :multiple="false"
              :beforeUpload="beforeUpload"
              :action="handleUpload"
            >
              <a-button type="ghost" icon="edit" size="small" 
                :disabled="data.profile && data.profile.status!='Aktif'" 
                :loading="loadingSetFoto"
              >
                Ganti Foto
              </a-button>
            </a-upload>
            <span v-else>&nbsp;</span>
            <a-button type="ghost" 
               v-if="getAuth.divisi[0] == 'HRD'"
              :icon="data.profile && data.profile.status!='Aktif'?'check-circle':'close-circle'" 
              size="small" @click="setnonAktif" :loading="loadingSetStatus">
              {{data.profile && data.profile.status=='Aktif'?'Set Non Aktif':'Set Aktif'}}
            </a-button>
          </div>
        </a-card>
      </a-col>
      <a-col
        :class="isMobile ? 'm-top' : ''"
        :xs="{ span: 24 }"
        :lg="{ span: 16 }"
        :xxl="{ span: 18 }"
      >
        <router-view :data="data" />
      </a-col>
    </a-row>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  props: ["id_siswa", "spesialFor"],
  name: "index.profile",
  data() {
    return {
      data: {
        profile: { 
          foto: null, 
          status:null,
          nama_lengkap: ""
        },
        employee: { jabatan: null },
        master:{
          jenis_kelamin:[]
        }
      },
      foto: [],
      current: this.$route.name,
      isHrd: false,
      isAllowed: true,
      datePicture: Date(),
      loadingSetStatus: false,
      loadingSetFoto: false
    };
  },
  computed: {
    ...mapGetters(["getAuth"]),
    clicked() {
      if (_.includes(this.$route.name, ".")) {
        let splits = _.split(this.$route.name, ".");
        return splits[splits.length - 1];
      } else {
        return this.$route.name;
      }
    },
    
  },
  created() {
    if (
      this.$router.currentRoute.name == "hrd.siswa.profile" ||
      this.getAuth.divisi[0] == "HRD"
    ) {
      this.isHrd = true;
    }
  },
  mounted() {
    this.fetching();
    Event.$on("fetching", this.fetching);
  },
  watch: {
    id_siswa() {
      this.fetching();
      this.current = "profile";
    },
  },
  methods: {
    async fetching() {
      const axios_profile = axios({
        method: "get",
        url: this.$serviceUrl + "internship",
        params: {
          id_siswa: this.id_siswa,
          tab:'profile'
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        if (err.response.data.message == "invalid access") {
          this.isAllowed = false;
        }
      });

      const axios_dokumen = axios({
        method: "get",
        url: this.$serviceUrl + "internship",
        params: {
          id_siswa: this.id_siswa,
          tab:'dokumen'
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        if (err.response.data.message == "invalid access") {
          this.isAllowed = false;
        }
      });

      const axios_kegiatan = axios({
        method: "get",
        url: this.$serviceUrl + "internship",
        params: {
          id_siswa: this.id_siswa,
          tab:'kegiatan'
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        if (err.response.data.message == "invalid access") {
          this.isAllowed = false;
        }
      });

      await new Promise(() => {
        axios.all([
          axios_profile,
          axios_dokumen,
          axios_kegiatan
        ]).then((response) => {
          this.isAllowed = true;
          this.data = {
            profile: response[0].data.data[0],
            dokumen: response[1].data.data[0],
            kegiatan: response[2].data.data[0],
            master: {
              jenis_identitas:response[0].data.jenis_identitas,
              jenis_kelamin:response[0].data.jenis_kelamin,
              sekolah:response[1].data.sekolah,
              divisi:response[2].data.divisi,
              pembimbing:response[2].data.pembimbing,
            }
          }
        })
      })
    },
    handleClick(e) {
      this.current = e.key;
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$message.error("You can only upload JPG or PNG file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("Image must smaller than 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleUpload(file) {
      let datas = new FormData();
      datas.append("foto", file);
      datas.append("id_siswa", this.data.profile.id_siswa);

      this.loadingSetFoto = true
      axios({
        method: "post",
        url: this.$serviceUrl + "internship/foto",
        processData: false,
        data: datas,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessage("success-edit");
          this.$refs.picProfiles.src = "";
          this.datePicture = new Date();
          this.loadingSetFoto = false
          // this.$router.go();
          Event.$emit("fetching");
        })
        .catch((err) => {
          return err;
        });
      // }
    },
    nonactivated(){
      let datas = new FormData();
      datas.append("id_siswa", this.data.profile.id_siswa);
      datas.append("status", this.data.profile.status=='Aktif'?'Non Aktif':'Aktif');

      this.loadingSetStatus = true
      axios({
        method: "post",
        url: this.$serviceUrl + "internship/status",
        processData: false,
        data: datas,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then(() => {
        this.displayMessage("success-edit");
        this.loadingSetStatus = false
        // this.$router.go();
        Event.$emit("fetching");
      })
      .catch((err) => {
        return err;
      });
    },
    setnonAktif(){
      const that = this
      const textOption = this.data.profile.status=='Aktif'?'me-non aktifkan':'mengaktifkan'
      this.$confirm({
        title: "Apakah anda yakin untuk "+textOption+" status siswa/mahasiswa ini?",
        content: '',
        okText: 'Ya',
        okType: 'danger',
        cancelText: 'Tidak',
        onOk() {
          that.nonactivated()
        },
        onCancel() { },
      });
    }
  },
};
</script>

<style></style>
